
// ============================================================
// MIRRORVANA — Support FAQ Link Arrows
// ============================================================

function injectFaqArrows() {
  document.querySelectorAll(
    '.menu-list__list-item:nth-child(4) .mega-menu__column:nth-child(1) ul a.mega-menu__link,' +
    '.menu-list__list-item:nth-child(4) .mega-menu__column:nth-child(2) ul a.mega-menu__link'
  ).forEach(a => {
    if (a.querySelector('.mv-link-arrow')) return;
    const arrow = document.createElement('span');
    arrow.className = 'mv-link-arrow';
    arrow.textContent = '→';
    a.appendChild(arrow);
  });
}

document.addEventListener('DOMContentLoaded', injectFaqArrows);
window.addEventListener('load', injectFaqArrows);

// Also fire on hover of the Support nav item — catches lazy-loaded menu HTML
document.addEventListener('mouseover', (e) => {
  const supportItem = e.target.closest('.menu-list__list-item:nth-child(4)');
  if (supportItem) injectFaqArrows();
});

// Observer — attach to document.body as fallback since menu may not exist on load
const faqArrowObserver = new MutationObserver(() => {
  injectFaqArrows();
});

document.addEventListener('DOMContentLoaded', () => {
  faqArrowObserver.observe(document.body, { childList: true, subtree: true });
});

// ============================================================
// MIRRORVANA — Predictive Search Popup (Open/Close)
// ============================================================

(function () {
  let pill, input, popup;
  function init() {
    pill  = document.getElementById('mvSearchPill');
    input = document.getElementById('mvSearchInput');
    popup = document.getElementById('mvSearchPopup');
    if (!pill || !input || !popup) return;
    const overlay = document.createElement('div');
    overlay.className = 'mv-search-overlay';
    overlay.id = 'mvSearchOverlay';
    document.body.appendChild(overlay);
    bindEvents();
    bindSearchInput();
  }

  function openPopup() {
    popup.classList.add('mv-popup--visible');
    pill.classList.add('mv-search-pill--active');
    document.getElementById('mvSearchOverlay').classList.add('is-active');
    document.body.style.overflow = 'hidden';
    loadRecentlyViewed();
    if (!input.value.trim()) showNoQueryState();
    if (window.innerWidth <= 1024 && !popup.querySelector('.mv-popup-mobile-header')) {
      var header = document.createElement('div');
      header.className = 'mv-popup-mobile-header';
      header.innerHTML = `
        <button class="mv-mobile-back-btn" id="mvMobileBackBtn">
          <svg viewBox="0 0 24 24" width="26" height="26" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12H4M11 5l-7 7 7 7"/></svg>
        </button>
        <div class="mv-mobile-search-bar">
          <svg class="mv-mobile-search-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4.35-4.35"/></svg>
          <input type="text" class="mv-mobile-search-input" id="mvMobileSearchInput" placeholder="Search" autocomplete="off" />
          <button class="mv-mobile-clear-circle" id="mvMobileClear" style="display:none">
            <svg viewBox="0 0 14 14" width="10" height="10" fill="none" stroke="white" stroke-width="2" stroke-linecap="round"><path d="M2 2l10 10M12 2L2 12"/></svg>
          </button>
        </div>
      `;
      popup.insertBefore(header, popup.firstChild);
      var mobileInput = document.getElementById('mvMobileSearchInput');
      var mobileClear = document.getElementById('mvMobileClear');
      var mobileClose = document.getElementById('mvMobileBackBtn');
      mobileInput.addEventListener('input', function() {
        input.value = mobileInput.value;
        input.dispatchEvent(new Event('input', {bubbles: true}));
        mobileClear.style.display = mobileInput.value.trim() ? '' : 'none';
      });
      mobileInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          var q = mobileInput.value.trim();
          if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
        }
      });
      mobileClear.addEventListener('click', function() {
        mobileInput.value = '';
        input.value = '';
        input.dispatchEvent(new Event('input', {bubbles: true}));
        mobileClear.style.display = 'none';
        mobileInput.focus();
      });
      mobileClose.addEventListener('click', function(e) {
        e.stopPropagation();
        mobileInput.value = '';
        input.value = '';
        closePopup();
      });
      mobileInput.focus();
      setTimeout(function() { mobileInput.focus(); }, 50);
    } else if (window.innerWidth <= 1024) {
      var existingInput = document.getElementById('mvMobileSearchInput');
      if (existingInput) {
        existingInput.focus();
        setTimeout(function() { existingInput.focus(); }, 50);
      }
    }
  }

  function closePopup() {
    popup.classList.remove('mv-popup--visible');
    pill.classList.remove('mv-search-pill--active');
    document.getElementById('mvSearchOverlay').classList.remove('is-active');
    document.body.style.overflow = '';
    var mobileHeader = popup.querySelector('.mv-popup-mobile-header');
    if (mobileHeader) mobileHeader.remove();
  }

  function bindEvents() {
    pill.addEventListener('touchend', (e) => { e.preventDefault(); openPopup(); });
    pill.addEventListener('click', (e) => { if (!('ontouchstart' in window)) openPopup(); });
    input.addEventListener('focus', (e) => { if (!('ontouchstart' in window) && window.innerWidth > 1024) openPopup(); });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closePopup();
    });
    document.addEventListener('click', e => {
  if (!popup.contains(e.target) && !pill.contains(e.target)) closePopup();
});


document.querySelectorAll('.menu-list__list-item').forEach(item => {
  item.addEventListener('mouseenter', closePopup);
});

document.addEventListener('click', e => {
  const pill = e.target.closest('.mv-keyword-pill');
  if (!pill) return;
  e.preventDefault();
  const text = pill.textContent.trim();
  input.value = text;
  // Also update mobile input if it exists
  const mobileInput = document.getElementById('mvMobileSearchInput');
  if (mobileInput) {
    mobileInput.value = text;
    mobileInput.focus();
  }
  input.dispatchEvent(new Event('input'));
});

    let lastWidth = window.innerWidth;
    window.addEventListener('resize', () => {
      const crossed = (lastWidth > 1024 && window.innerWidth <= 1024) || (lastWidth <= 1024 && window.innerWidth > 1024);
      lastWidth = window.innerWidth;
      if (crossed && popup.classList.contains('mv-popup--visible')) closePopup();
    });
  }

function showNoQueryState() {
    document.getElementById('mvNoQueryState').style.cssText = '';
    document.getElementById('mvQueryState').style.cssText = 'display:none !important';
    document.getElementById('mvFooterLink').innerHTML = `Browse all products and guides <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6h8M7 3l3 3-3 3"/></svg>`;
    document.getElementById('mvFooterLink').href = '/search';
  }

  function showQueryState(q) {
    document.getElementById('mvNoQueryState').style.cssText = 'display:none !important';
    document.getElementById('mvQueryState').style.cssText = '';
    document.getElementById('mvFooterLink').innerHTML = `View all results for "<strong>${q}</strong>" <svg viewBox="0 0 12 12" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M2 6h8M7 3l3 3-3 3"/></svg>`;
    document.getElementById('mvFooterLink').href = '/search?q=' + encodeURIComponent(q);
  }

  let searchDebounce = null;

  function highlight(text, q) {
    if (!q || !text) return text;
    const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return text.replace(new RegExp(`(${escaped})`, 'gi'), '<mark>$1</mark>');
  }

  function renderArticles(articles, q) {
    const results = document.getElementById('mvArticleResults');
    const fallback = document.getElementById('mvArticleFallback');
    if (!articles.length) {
      results.innerHTML = '';
      fallback.style.display = '';
      return;
    }
    fallback.style.display = 'none';
    results.innerHTML = `
      <p class="mv-section-label">Articles</p>
      <div class="mv-article-list">
        ${articles.map(a => `
        <a href="${a.url}" class="mv-article-item">
          <div class="mv-article-thumb">
            ${a.featured_image && a.featured_image.url
              ? `<img src="${a.featured_image.url}" alt="${a.title}" loading="lazy">`
              : ''}
          </div>
          <div class="mv-article-body">
            <p class="mv-article-title">${a.title}</p>
            <p class="mv-article-snippet">${a.body ? a.body.replace(/<[^>]*>/g, '').substring(0, 80) + '...' : ''}</p>
          </div>
        </a>`).join('')}
      </div>`;
  }

function renderPages(pages, faqArticles, q) {
  const el = document.getElementById('mvArticleResults');
  const allPages = [
  ...pages.map(p => ({ url: p.url, title: p.title, isFaq: false })),
  ...faqArticles.map(a => ({ url: a.url, title: a.title, isFaq: true }))
];
  if (!allPages.length) return;
  el.innerHTML += `
    <p class="mv-section-label" style="margin-top:16px">Pages & FAQs</p>
    <div class="mv-article-list">
      ${allPages.map(p => `
      <a href="${p.url}" class="mv-article-item mv-article-item--page">
        <div class="mv-article-thumb" style="background:#f1f3f5;display:flex;align-items:center;justify-content:center;">
          ${p.isFaq
            ? `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/><circle cx="12" cy="17" r="0.5" fill="#1a1a1a"/></svg>`
            : `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="1.5"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>`}
        </div>
        <div class="mv-article-body">
          <p class="mv-article-title">${highlight(p.title, q)}</p>
        </div>
      </a>`).join('')}
    </div>`;
}

  function renderQueries(queries, q) {
    const el = document.getElementById('mvQueryResults');
    if (!queries.length) { el.innerHTML = ''; return; }
    el.innerHTML = `
      <p class="mv-section-label">Suggestions</p>
      <div class="mv-keyword-pills">
        ${queries.map(item => `
        <a href="/search?q=${encodeURIComponent(item.text)}" class="mv-keyword-pill">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="6.5" cy="6.5" r="4"/><path d="m12 12-2.5-2.5"/></svg>
          ${item.text}
        </a>`).join('')}
      </div>`;
  }

  function renderProducts(products, q) {
  const el = document.getElementById('mvQueryResults');
  if (!products.length) return;
  el.innerHTML += `
    <p class="mv-section-label">Products</p>
    <div class="mv-product-grid">
      ${products.map(p => {
        const price = p.price ? parseFloat(p.price) : null;
        const comparePrice = p.compare_at_price_max ? parseFloat(p.compare_at_price_max) : null;
        const onSale = comparePrice && comparePrice > price;
        const badge = onSale
          ? `<span class="mv-product-badge mv-badge--sale">Sale</span>`
          : '';
        return `
        <a href="/products/${p.handle}" class="mv-product-card">
          <div class="mv-product-thumb">
            ${p.image
              ? `<img src="${p.image}" alt="${p.title}" loading="lazy">`
              : ''}
            ${badge}
          </div>
          <div class="mv-product-info">
            <p class="mv-product-name">${p.title}</p>
            <div class="mv-product-price-row">
              ${price ? `<span class="mv-product-price">$${price.toFixed(2)}</span>` : ''}
              ${onSale ? `<span class="mv-product-price-old">$${comparePrice.toFixed(2)}</span>` : ''}
            </div>
          </div>
        </a>`;
      }).join('')}
    </div>`;
}

  function renderCollections(collections) {
    const el = document.getElementById('mvQueryResults');
    if (!collections.length) return;
    el.innerHTML += `
      <p class="mv-section-label">Collections</p>
      <div class="mv-collection-grid">
        ${collections.map(c => `
        <a href="${c.url}" class="mv-collection-card">
          <div class="mv-collection-thumb">
            ${c.featured_image && c.featured_image.url
              ? `<img src="${c.featured_image.url}" alt="${c.title}" loading="lazy">`
              : '<div class="mv-collection-placeholder"></div>'}
          </div>
          <p class="mv-collection-title">${c.title}</p>
        </a>`).join('')}
      </div>`;
  }

  async function fetchFullProducts(handles) {
    const results = await Promise.all(
      handles.map(h => fetch(`/products/${h}.json`).then(r => r.json()).then(d => d.product).catch(() => null))
    );
    return results.filter(Boolean);
  }

  let fetchId = 0;
  async function fetchPredictive(q) {
    const thisId = ++fetchId;
    document.getElementById('mvQueryResults').innerHTML = '';
    document.getElementById('mvArticleResults').innerHTML = '';
  try {
    const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,article,collection,query,page&resources[limit_scope]=each&resources[limit]=8`);
    if (!res.ok) throw new Error();
    const data = await res.json();
    const r = data.resources.results;
    renderQueries(r.queries.slice(0, 5) || [], q);
    const journalArticles = (r.articles || []).filter(a => a.url && a.url.includes('/blogs/journal'));
    const faqArticles = (r.articles || []).filter(a => a.url && !a.url.includes('/blogs/journal'));
    renderArticles(journalArticles.slice(0, 4), q);
    renderPages(r.pages.slice(0, 3) || [], faqArticles.slice(0, 4) || [], q);
    if (thisId !== fetchId) return;
    const filteredProducts = (r.products || []).filter(p => !/case pack/i.test(p.title));
    renderProducts(filteredProducts.slice(0, 8), q);
    renderCollections(r.collections.slice(0, 8) || []);


    const rightPanel = document.getElementById('mvQueryResults');
    if (!rightPanel.innerHTML.trim()) {
      rightPanel.innerHTML = `
        <div class="mv-empty-state">
          <p class="mv-empty-state__title">No results for "<strong>${q}</strong>"</p>
          <p class="mv-empty-state__sub" style="margin-bottom:24px">Try a different keyword or browse our <a href="/collections/all" class="mv-empty-state__link">full collection</a></p>
          <p class="mv-section-label" style="margin-top:50px">Popular Searches</p>
          <div class="mv-keyword-pills">
            <a href="/search?q=fogless+shower+mirror" class="mv-keyword-pill"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="6.5" cy="6.5" r="4"/><path d="m12 12-2.5-2.5"/></svg>fogless shower mirror</a>
            <a href="/search?q=suction+cup+mirror" class="mv-keyword-pill"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="6.5" cy="6.5" r="4"/><path d="m12 12-2.5-2.5"/></svg>suction cup mirror</a>
            <a href="/search?q=magnifying+mirror" class="mv-keyword-pill"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="6.5" cy="6.5" r="4"/><path d="m12 12-2.5-2.5"/></svg>magnifying mirror</a>
            <a href="/search?q=tabletop+mirror" class="mv-keyword-pill"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="6.5" cy="6.5" r="4"/><path d="m12 12-2.5-2.5"/></svg>tabletop mirror</a>
            <a href="/search?q=mirror+for+travel" class="mv-keyword-pill"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="6.5" cy="6.5" r="4"/><path d="m12 12-2.5-2.5"/></svg>mirror for travel</a>
            <a href="/search?q=makeup+mirror" class="mv-keyword-pill"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="6.5" cy="6.5" r="4"/><path d="m12 12-2.5-2.5"/></svg>makeup mirror</a>
            <a href="/search?q=hand+mirror" class="mv-keyword-pill"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="6.5" cy="6.5" r="4"/><path d="m12 12-2.5-2.5"/></svg>hand mirror</a>
            <a href="/search?q=wall+mounted+mirror" class="mv-keyword-pill"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><circle cx="6.5" cy="6.5" r="4"/><path d="m12 12-2.5-2.5"/></svg>wall mounted mirror</a>
          </div>
        </div>`;
    }

  } catch(e) {
    console.warn('[MV Search] Fetch error:', e);
  }
}


let recentlyViewedLoaded = false;
  async function loadRecentlyViewed() {
    if (recentlyViewedLoaded) return;
    try {
      const ids = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
      if (!ids.length) return;
      const query = ids.slice(0, 4).map(id => `id:${id}`).join(' OR ');
      const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`);
      if (!res.ok) throw new Error();
      const data = await res.json();
      const products = data.resources?.results?.products || [];
      if (!products.length) return;
      const grid = document.getElementById('mvRecentlyViewed');
      const section = document.getElementById('mvRecentlyViewedSection');
      if (!grid || !section) return;
      grid.innerHTML = products.map(p => {
        const price = p.price ? parseFloat(p.price) : null;
        const comparePrice = p.compare_at_price_max ? parseFloat(p.compare_at_price_max) : null;
        const onSale = comparePrice && comparePrice > price;
        const badge = onSale
          ? `<span class="mv-product-badge mv-badge--sale">Sale</span>`
          : '';
        return `
        <a href="/products/${p.handle}" class="mv-product-card">
          <div class="mv-product-thumb">
            ${p.featured_image?.url
              ? `<img src="${p.featured_image.url}" alt="${p.title}" loading="lazy">`
              : ''}
            ${badge}
          </div>
          <div class="mv-product-info">
            <p class="mv-product-name">${p.title}</p>
            <div class="mv-product-price-row">
              ${price ? `<span class="mv-product-price">$${price}</span>` : ''}
              ${onSale ? `<span class="mv-product-price-old">$${comparePrice}</span>` : ''}
            </div>
          </div>
        </a>`;
      }).join('');
      section.style.display = '';
      recentlyViewedLoaded = true;
    } catch(e) {
      console.warn('[MV] Recently viewed error:', e);
    }
  }




  function bindSearchInput() {
    input.addEventListener('input', () => {
      const q = input.value.trim();
      clearTimeout(searchDebounce);
      if (q.length === 0) {
        showNoQueryState();
        return;
      }
      showQueryState(q);
      searchDebounce = setTimeout(() => fetchPredictive(q), 50);
    });




    input.addEventListener('keydown', e => {
      if (e.key === 'Enter') {
        const q = input.value.trim();
        if (q) window.location.href = '/search?q=' + encodeURIComponent(q);
      }
    });
  }




  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();


// ── Search Tabs ──
document.addEventListener('DOMContentLoaded', () => {
  if (!window.mvSearch) return;
  const s = window.mvSearch;
  const el = id => document.getElementById(id);


  // Set counts
  if (el('mvCountAll'))      el('mvCountAll').textContent      = `(${s.total})`;
  if (el('mvCountProducts')) el('mvCountProducts').textContent = `(${s.products})`;
  if (el('mvCountArticles')) el('mvCountArticles').textContent = `(${s.articles})`;
  if (el('mvCountFaqs'))     el('mvCountFaqs').textContent     = `(${s.faqs + s.pages})`;


  // Tab switching
  const tabs = document.querySelectorAll('.mv-search-tab');
  const resultsList = document.getElementById('ResultsList');


  function setTab(tab) {
    tabs.forEach(t => t.classList.remove('active'));
    tab.classList.add('active');
    const active = tab.dataset.tab;
    document.body.setAttribute('data-mv-tab', active);


    // Products always visible
    if (resultsList) resultsList.style.display = '';
    const productsLabel = el('mvProductsLabel');
    if (productsLabel) productsLabel.style.display = '';

    // Articles + FAQs always visible
    const articlesPanel = el('mvArticlesPanel');
    const faqsPanel = el('mvFaqsPanel');
    if (articlesPanel) articlesPanel.style.display = '';
    if (faqsPanel) faqsPanel.style.display = '';

    // Scroll to section
    const targets = {
      'products': el('mvProductsLabel') || resultsList,
      'articles': articlesPanel,
      'faqs':     faqsPanel
    };
    if (active === 'all') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (targets[active]) {
      setTimeout(() => {
        targets[active].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  }


  tabs.forEach(tab => {
    tab.addEventListener('click', () => setTab(tab));
  });






// ── Fetch journal articles for search results page ──
async function fetchSearchArticles(q) {
  if (!q) return;
  try {
    const allArticles = window.mvSearch?.articleData || [];
    const journalArticles = allArticles.filter(a => a.url && a.url.includes('/blogs/journal'));
    const faqArticles = allArticles.filter(a => a.url && !a.url.includes('/blogs/journal'));


    // Render articles panel
    const panel = el('mvArticlesPanel');
    if (!panel) return;
    const label = panel.querySelector('.mv-extras-section-label');
    if (journalArticles.length > 0) {
      const html = journalArticles.map(a => `
        <a href="${a.url}" class="mv-extras-article-row">
          <div class="mv-extras-article-thumb">
            ${a.image ? `<img src="${a.image}" alt="${a.title}" loading="lazy">` : ''}
          </div>
          <div class="mv-extras-article-body">
            <div class="mv-extras-breadcrumb">mirrorvana.com › journal</div>
            <div class="mv-extras-article-title">${a.title}</div>
            <div class="mv-extras-article-excerpt">${a.excerpt || ''}</div>
          </div>
        </a>`).join('');
      panel.innerHTML = '';
      if (label) panel.appendChild(label);
      const list = document.createElement('div');
      list.className = 'mv-extras-article-list';
      list.innerHTML = html;
      panel.appendChild(list);
    } else {
      const empty = panel.querySelector('.mv-extras-empty') || document.createElement('div');
      empty.className = 'mv-extras-empty';
      empty.innerHTML = '<p>No articles matched your search.</p><a href="/blogs/journal">Browse our Journal →</a>';
      panel.innerHTML = '';
      if (label) panel.appendChild(label);
      panel.appendChild(empty);
    }
  } catch(e) {
    console.warn('[MV] Article fetch error:', e);
  }
}




// Get search query from URL and fetch articles
const urlParams = new URLSearchParams(window.location.search);
const searchQuery = urlParams.get('q');
if (searchQuery && document.getElementById('mvArticlesPanel')) {
  fetchSearchArticles(searchQuery);
}




  // Set default
  setTab(tabs[0]);
});



























